<template>
	<div class="edit-address">
		<div class="title">申请返修</div>

		<div class="input-box">
			<div class="title">返修意见：</div>
			<Radio-group name="rating" v-model="refund.rating" style="margin-left:20px">
				<Radio v-for="(v, k) in ratingList" :label="v.rating" :key="`ra`+k">
					<span>{{v.title}}</span>
				</Radio>
			</Radio-group>
		</div>
		<div class="input-box">
			<div class="title">返修意见：</div>
			<textarea  v-model="refund.description" placeholder="请填写返修意见" ></textarea>
		</div>
		<button class="save" @click="save">提交</button>

	</div>
</template>

<script>
	import { ApplyRefund } from "@/api"
	export default {
		name: 'ApplyFixing',
		components: {

		},
		data() {
			return {
				refund_id: 0,
				refund: {
					order_id: 0,
					description:'',
					rating:2
				},
				ratingList:[
					{
						rating:2,
						title: '整体比较满意'
					},
					{
						rating:1,
						title: '一般'
					},
					{
						rating:0,
						title: '比预期差很多'
					}
				]
			};
		},
		created() {
			this.refund.order_id = this.$route.query.id
		},
		methods: {
			async save() {
				if(!this.refund.description) {
					this.$Notice.error({
						title: '请填写修改意见',
						duration: 1,
					})
					return
				}


				let res = await ApplyRefund(this.refund)
				this.$Notice.success({
					title:  '提交成功',
				});
				this.$router.replace({
					name: "FixingList"
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.edit-address {
		width: 950px;
		height: 560px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		padding: 20px;

		.title {
			font-size: 20px;
			font-weight: bold;
			color: #333333;
			margin-bottom: 20px;
		}

		.input-box {
			margin-bottom: 30px;
			display: flex;

			.title {
				width: 86px;

				font-size: 14px;
				color: #666666;
			}

			input {
				width: 440px;
				height: 40px;
				line-height: 40px;
				background: #FFFFFF;
				border: 1px solid #dcdee2;
				padding-left: 20px;
				color: #333333;
			}

			textarea {
				width: 440px;
				height: 80px;
				border: 1px solid #dcdee2;
				padding-left: 20px;
				padding-top: 10px;
			}
		}

		.save {
			width: 100px;
			height: 40px;
			line-height: 40px;
			background: #0F114A;
			text-align: center;
			font-size: 14px;
			color: #FFFFFF;
			margin-left: 86px;
			padding-bottom: 30px;
		}

		.default {
			margin-left: 86px;
			padding-bottom: 20px;

			.ivu-checkbox-checked .ivu-checkbox-inner {

				border-color: #0F114A !important;
				background-color: #0F114A !important;
			}
		}
	}
</style>
